import { Trans } from '@lingui/macro'
import { Currency } from '@uniswap/sdk-core'
import { TableDataContainer } from 'components/Table'
import { PAGE_SIZE } from 'graphql/data/TopTokens'
import { IPoolSwapUser } from 'hooks/useQueryLiquidity'
import { GridContainer, NoTokensState } from 'pages/Liquidity/Table'
import { AlertTriangle } from 'react-feather'

import { HeaderRow, LoadedRow, LoadingRow } from './DetailRow'

const LoadingRows = ({ rowCount }: { rowCount: number }) => (
  <>
    {Array(rowCount)
      .fill(null)
      .map((_, index) => {
        return <LoadingRow key={index} first={index === 0} last={index === rowCount - 1} />
      })}
  </>
)

function LoadingTokenTable({ rowCount = PAGE_SIZE }: { rowCount?: number }) {
  return (
    <GridContainer>
      <HeaderRow />
      <TableDataContainer>
        <LoadingRows rowCount={rowCount} />
      </TableDataContainer>
    </GridContainer>
  )
}

export default function Table({ tableInfo, token }: { tableInfo?: IPoolSwapUser[]; token?: Currency }) {
  const loadingLeaderboards = true
  const leaderboardList = tableInfo
  if (loadingLeaderboards && !leaderboardList) {
    return <LoadingTokenTable rowCount={PAGE_SIZE} />
  } else if (!leaderboardList) {
    return (
      <NoTokensState thRow={<HeaderRow />}
        message={
          <>
            <AlertTriangle size={16} />
            <Trans>An error occurred loading leaderboardList. Please try again.</Trans>
          </>
        }
      />
    )
  } else if (leaderboardList?.length === 0) {
    return <NoTokensState thRow={<HeaderRow />} message={<Trans>No leaderboardList found</Trans>} />
  } else {
    return (
      <>
        <HeaderRow />
        <TableDataContainer>
          {leaderboardList
            .slice()
            .sort((a, b) => Number(b.totalValume) - Number(a.totalValume))
            .map((leaderboard, index) => (
              <LoadedRow
                key={index}
                token={token}
                leaderboardListIndex={index}
                leaderboardListLength={leaderboardList.length}
                leaderboard={leaderboard}
              />
            ))}
        </TableDataContainer>
      </>
    )
  }
}
